import React, { useState } from 'react';
import { useToggle } from 'react-use';

const isValidCode = (code) => /^\d{6}$/.test(code);

// 【stg 復旧用の暫定対応】2要素目(TOTP)を登録済みのユーザーが、1要素目(メールリンク・Google)の後に認証アプリの6桁コードを入力するフォーム。
// 本番に出す想定ではないため、わざと装飾なしの素の要素だけで組んでいる。MFA の本実装をマージするときに削除すること
export default function TotpSignInForm(props) {
  const { onSubmit: _onSubmit, onClickCancel } = props;
  const [code, setCode] = useState('');
  const [isProcessing, toggleProcessing] = useToggle(false);
  const onSubmit = async (event) => {
    event.preventDefault();
    if(!isValidCode(code)) return;

    toggleProcessing(true);
    await _onSubmit({ code });
    toggleProcessing(false);
  };
  const onClickBack = (event) => {
    event.preventDefault();
    onClickCancel();
  };

  return (
    <form onSubmit={onSubmit}>
      <div>
        <label>
          2段階認証の認証アプリに表示されている6桁の認証コードを入力してください。
          <input value={code} onChange={_ => setCode(_.target.value.trim())} inputMode="numeric" autoComplete="one-time-code" maxLength={6} autoFocus />
        </label>
      </div>
      <div>
        <button type="submit" disabled={!isValidCode(code) || isProcessing}>認証する</button>
      </div>
      <div>
        <a href="/" onClick={onClickBack}>ログイン画面へ戻る</a>
      </div>
    </form>
  );
};
